import React, { useCallback } from 'react';
import { useFocusEffect } from 'expo-router';
import { Platform } from 'react-native';

import { useFeatureFlag } from '@order/LaunchDarkly';

import {
  LoyaltyOffers,
  LoyaltyPostPurchaseModal,
  usePostPurchaseModalState,
} from '../../components';
import { useIsLoggedIn } from '../../context/AuthMachine';
import { useBraze } from '../../context/Braze';
import {
  useLogLoyaltyOnboardingModalEvents,
  useOnOnboardingModalShow,
  useOtaOnScreenFocus,
  useTrackLoyaltyOnboardingModal,
} from '../../hooks';
import { HomeScreenContent, HomeScreenContentV2 } from './components';
import { useOpenChatFromHomeScreen } from './hooks';

export const HomeScreen = () => {
  const logLoyaltyOnboardingModalEvents = useLogLoyaltyOnboardingModalEvents();
  const trackLoyaltyOnboardingModal = useTrackLoyaltyOnboardingModal();
  const openChatFromHomeScreen = useOpenChatFromHomeScreen();
  const postPurchaseModalState = usePostPurchaseModalState();
  const { logCustomEvent } = useBraze();
  const isLoggedIn = useIsLoggedIn();

  const isHomeRedesignEnabled = useFeatureFlag('CELS-5283-home-redesign-enabled');

  // ─── Helpers ─────────────────────────────────────────────────────────

  const hidePostPurchaseModal = useCallback(() => {
    // NOTE: We use a short delay on iOS because of a known issue during
    //       interactions between two modals.
    const delay = Platform.select({ ios: 1000, default: 0 });

    setTimeout(postPurchaseModalState.hideModal, delay);
  }, [postPurchaseModalState.hideModal]);

  // NOTE: Post-purchase modal should be hidden when the loyalty onboarding in-app message is shown.
  const hideOffersOnOnboardingModalShow = useOnOnboardingModalShow({
    onModalShow: hidePostPurchaseModal,
  });

  const logHomeViewedBrazeEvent = useCallback(() => {
    logCustomEvent('home.viewed', { isLoggedIn });
  }, [isLoggedIn, logCustomEvent]);

  // ─── Effects ─────────────────────────────────────────────────────────

  useOtaOnScreenFocus();

  useFocusEffect(hideOffersOnOnboardingModalShow);
  useFocusEffect(trackLoyaltyOnboardingModal);
  useFocusEffect(logLoyaltyOnboardingModalEvents);
  useFocusEffect(openChatFromHomeScreen);
  useFocusEffect(logHomeViewedBrazeEvent);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <>
      {isHomeRedesignEnabled ? <HomeScreenContentV2 /> : <HomeScreenContent />}
      <LoyaltyOffers.Modal />
      <LoyaltyPostPurchaseModal />
    </>
  );
};
